export default __webpack_public_path__ + "static/media/slider-11.2ba7d6f3.png";